import React from 'react';

const SkeletonCard = ({ featured = false }) => (
  <div className={`skeleton-card${featured ? ' skeleton-card--featured' : ''}`}>
    <div className="skeleton-img" style={featured ? { height: '260px' } : {}} />
    <div className="skeleton-body">
      <div className="skeleton-line skeleton-line--short" />
      <div className="skeleton-line skeleton-line--title" />
      <div className="skeleton-line skeleton-line--full" />
      <div className="skeleton-line skeleton-line--mid" />
    </div>
  </div>
);

const BlogSkeleton = ({ count = 6 }) => (
  <div className="skeleton-grid">
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonCard key={i} featured={i === 0} />
    ))}
  </div>
);

export default BlogSkeleton;